import styled from 'styled-components';

export const ContainerSection = styled.section`
  margin: 5px 0;
  padding: 5px;
  border: ${({ theme }) => {
    return theme.border;
  }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  h3 {
    font-size: ${({ theme }) => {
      return theme.fonts.size.big;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    cursor: pointer;
    margin: 5px 0;
    padding: 0 0 5px 0;
    border-bottom: ${({ theme }) => {
      return theme.border;
    }};
  }
  h4 {
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
`;
